// extracted by mini-css-extract-plugin
export var banner = "_qg-0";
export var settingRow = "_qg-2";
export var titleIcon = "_qg-1";